import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Modal from 'components/player/shared/modal/component';
import AuthLogo from 'components/auth/shared/logo/component';
import { setT } from 'helpers/translationUtilities';
import { PURGE_ALL_APP_DATA } from 'components/constants';
export default function DisconnectNotificationModal() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    function logoutFromApp() {
        dispatch({ type: PURGE_ALL_APP_DATA });
        navigate('/token');
    }
    return (React.createElement(Modal, { expanded: true, lightboxClasses: 'bg-transparent', modalInnerClasses: 'text-align-center', lightboxUnclosable: true },
        React.createElement("div", null,
            React.createElement(AuthLogo, null),
            React.createElement("h2", { className: "color-primary" }, setT('connection_lost'))),
        React.createElement("div", { className: "d-flex flex-align-center flex-justify-content-center", style: { gap: '12px' } },
            React.createElement("button", { className: "main-button main-button--lg", onClick: function () { return logoutFromApp(); } }, setT('to_login')),
            React.createElement("button", { className: "main-button main-button--lg", onClick: function () { return window.location.reload(); } }, setT('reconnect')))));
}
